import { memo, useCallback, useRef } from 'react';
import Item from './Item'

const SelectionCard = ({
  options,
  selectedOption,
  onPress,
  btnStyle = "btn flex w-full sm:w-[49%] lg:w-[24%] mb-2 rounded-xl",
  selectedStyle = "btn-neutral bg-secondary-900 text-white hover:bg-secondary-800",
  unselectedStyle = "border-gray-300 btn-outline text-gray-500 hover:bg-gray-50 hover:text-gray-700",
  isMultiSelect = false,
  handleAsBoolean = false,
  error = null
}) => {

  const selectedOptionRef = useRef(selectedOption);
  selectedOptionRef.current = selectedOption;

  const handleClick = useCallback((title: string) => {
    let currentSelected = selectedOptionRef.current;

    if (handleAsBoolean) {
      if (isMultiSelect)
        onPress({ ...currentSelected, [title]: !currentSelected[title] });
      else {
        onPress(
          Object.keys(currentSelected).reduce((value, key) => {
            value[key] = key === title;
            return value;
          }, {})
        );
      }

      return
    }

    if (isMultiSelect) {
      onPress(
        currentSelected.includes(title)
          ? currentSelected.filter((item: any) => item !== title)
          : [title, ...currentSelected]
      );
    } else {
      onPress(title);
    }
  }, [isMultiSelect, onPress]);

  return (
    <div className="mb-5">
      <div className="flex flex-row justify-between flex-wrap">
        {options.map((_option: any, index: number) => {
          let { title } = _option || {}

          let isSelected = false
          if (handleAsBoolean) isSelected = selectedOptionRef.current[title];
          else isSelected = isMultiSelect ? selectedOption.includes(title) : title === selectedOption;

          return (
            <Item
              key={`selection-item-${title}-${index}`}
              btnStyle={btnStyle}
              selectedStyle={selectedStyle}
              unselectedStyle={unselectedStyle}
              handleClick={handleClick}
              option={_option}
              isSelected={isSelected}
            />
          )
        })}
      </div>

      {error && <p className="text-error text-xs mt-1 ml-1">{error}</p>}
    </div>
  )
}

const areEqual = (prevProps: any, nextProps: any) => {
  return (
    prevProps.options === nextProps.options &&
    prevProps.selectedOption === nextProps.selectedOption &&
    prevProps.error === nextProps.error
  )
}

export default memo(SelectionCard, areEqual);
